module.exports = __webpack_public_path__ + "img/03-326x184-bishop.5efff91e.jpg";